<header motif-header class="pmproheader">
  <button
    *ngIf="hideMenu"
    class="side-btn"
    aria-controls="vertical-navigation-menu"
    aria-label="Open and close menu button"
    motif-header-menu
    (click)="toggleMenu()"
    position="left"
    [attr.aria-expanded]="showMenu"
  ></button>
  <img
    [ngClass]="{ 'margin-left': !hideMenu }"
    *ngIf="selectedTheme == 'dark'"
    motif-header-logo
    alt="PM Pro"
    src="assets/images/new-logo.png"
    position="left"
  />
  <img
    [ngClass]="{ 'margin-left': !hideMenu }"
    *ngIf="selectedTheme == 'light'"
    motif-header-logo
    alt="PM Pro"
    src="assets/images/new-logo.png"
    position="left"
  />

  <div motif-header-title position="left" class="titleContainer">
    <div class="projectTitle">
      <a routerLink="/" (click)="showNavMenu()">
        @if (isPmproLoaded) {
          <img
            [ngClass]="{ 'margin-left': !hideMenu }"
            *ngIf="selectedTheme == 'dark'"
            motif-header-logo
            alt="PM Pro"
            src="assets/images/pmpro-name-dark.svg"
            position="left"
          />
          <img
            [ngClass]="{ 'margin-left': !hideMenu }"
            *ngIf="selectedTheme == 'light'"
            motif-header-logo
            alt="PM Pro"
            src="assets/images/pmpro-name.svg"
            position="left"
          />
        } @else {
          <img
            [ngClass]="{ 'margin-left': !hideMenu }"
            *ngIf="selectedTheme == 'dark'"
            motif-header-logo
            alt="IPO Ready"
            src="assets/images/ipo-ready-logo-lg-dark.svg"
            position="left"
          />
          <img
            [ngClass]="{ 'margin-left': !hideMenu }"
            *ngIf="selectedTheme == 'light'"
            motif-header-logo
            alt="IPO Ready"
            src="assets/images/ipo-ready-logo-lg.svg"
            position="left"
          />
        }
      </a>
    </div>
    <div class="subText2">
      <span class="powered-by-text">{{ "PoweredByMessage" | translate }}</span
      ><span class="sl-color"> {{ "FAAS" | translate }} </span>
    </div>
  </div>

  <div *ngIf="isLanding" class="toggle-container" position="right">
    <img
      [ngClass]="{ 'margin-left': !hideMenu }"
      *ngIf="selectedTheme == 'dark'"
      motif-header-logo
      alt="PM Pro"
      [src]="
        isPmproLoaded
          ? 'assets/images/ipoready-logo-bw.png'
          : 'assets/images/ipo-ready-logo-lg-dark.svg'
      "
      position="left"
    />
    <img
      [ngClass]="{ 'margin-left': !hideMenu }"
      *ngIf="selectedTheme == 'light'"
      motif-header-logo
      alt="PM Pro"
      [src]="
        isPmproLoaded
          ? 'assets/images/ipoready-logo-bw.png'
          : 'assets/images/ipo-ready-logo-lg.svg'
      "
      position="left"
    />
    <motif-toggle-switch
      class="m-0 toggle-projects"
      name="toggleProjects"
      prelabel="{{ 'IPOReady' | translate }}"
      postlabel="{{ 'PMPRO' | translate }}"
      (change)="toggleProject($event)"
      [hideLabels]="true"
      position="left"
      [value]="isPmproLoaded"
    ></motif-toggle-switch>
    <img
      [ngClass]="{ 'margin-left': !hideMenu }"
      *ngIf="selectedTheme == 'dark'"
      motif-header-logo
      alt="PM Pro"
      [src]="
        isPmproLoaded
          ? 'assets/images/pmpro-name-dark.svg'
          : 'assets/images/pmpro-logo-bw.png'
      "
      position="left"
    />
    <img
      [ngClass]="{ 'margin-left': !hideMenu }"
      *ngIf="selectedTheme == 'light'"
      motif-header-logo
      alt="PM Pro"
      [src]="
        isPmproLoaded
          ? 'assets/images/pmpro-name.svg'
          : 'assets/images/pmpro-logo-bw.png'
      "
      position="left"
    />
  </div>

  <button
    motif-header-icon
    position="right"
    aria-label="Notification Button"
    size="medium"
    class="notification-button"
    (click)="openNotifications()"
  >
    <motif-icon
      [iconFunction]="bellIcon"
      size="medium"
      class="bellIcon"
    ></motif-icon>
    <span *ngIf="unreadCount > 0" class="notification-badge">{{
      unreadCount
    }}</span>
  </button>

  <div
    class="motif-dropdown-avatar"
    motifDropdown
    motif-header-avatar
    position="right"
    size="medium"
  >
    <button
      motifDropdownToggle
      aria-label="Example avatar button"
      id="exampleAvatarButton"
    >
      <motif-avatar
        [ngClass]="{ 'margin-left-1': !hideMenu }"
        [src]="commonService.profileImage(userImage)"
        size="small"
        userName="{{ user?.displayName }}"
        size="medium"
        description="{{ user?.displayName }}"
      ></motif-avatar>
    </button>
    <div
      motifDropdownMenu
      class="headerDropdown"
      aria-labelledby="exampleAvatarButton"
    >
      <div class="p-14">
        <motif-button-group role="group" aria-label="button group example">
          <button
            motifButton
            size="small"
            (click)="setTheme('auto')"
            [disabled]="theme === 'auto'"
          >
            {{ "Auto" | translate }}
          </button>
          <button
            motifButton
            size="small"
            (click)="setTheme('dark')"
            [disabled]="theme === 'dark'"
          >
            <motif-icon [iconFunction]="IconoirHalfMoon"></motif-icon
            >{{ "Dark" | translate }}
          </button>
          <button
            motifButton
            size="small"
            (click)="setTheme('light')"
            [disabled]="theme === 'light'"
          >
            <motif-icon [iconFunction]="IconoirSunLight"></motif-icon>
            {{ "Light" | translate }}
          </button>
        </motif-button-group>
      </div>
      <hr class="dropdown-divider" />
      <div class="dropdown-avatar-item" motifDropdownItem>
        <motif-avatar
          status="online"
          [src]="commonService.profileImage(userImage)"
          userName="{{ user?.displayName }}"
          description="{{ user?.displayName }}"
        ></motif-avatar>
        <div class="avatar-name">
          <span class="motif-body1-default-regular">{{
            user?.displayName
          }}</span>
          <span class="motif-body1-default-light">{{ user?.mail }}</span>
        </div>
      </div>
      <hr class="dropdown-divider" />
      <button motifDropdownItem>
        <motif-icon [iconFunction]="IconoirUser" />
        {{ "Profile" | translate }}
      </button>
      <hr class="dropdown-divider" />
      <button motifDropdownItem (click)="showPrivacyNotice()">
        <motif-icon [iconFunction]="privacyPolicyIcon" />
        {{ "PrivacyPolicy" | translate }}
      </button>

      <hr class="dropdown-divider" />
      <button motifDropdownItem (click)="logout()">
        <motif-icon [iconFunction]="IconoirLogOut" />
        {{ "Logout" | translate }}
      </button>
    </div>
  </div>
</header>

<div class="header-toastmessage">
  <motif-toast
    [type]="toastMessage.toastType"
    [(show)]="toastMessage.toastShow"
    [duration]="toastMessage.toastDuration"
    >{{ toastMessage.toastMessage }}</motif-toast
  >
</div>
